import {Component, ViewChild} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {Api, User} from '../../providers';
import {PostPage} from "../post/post.page";
import {EditUserPage} from "../edit-user/edit-user.page";
import {UsersPage} from "../users/users.page";
import { Router,ActivatedRoute } from '@angular/router';
import { MenuController } from '@ionic/angular';


@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage {
    public file:File;
    public uidkey:string;
    public uid:string='';
    public owner:boolean;
    public direct:boolean=false;
    public loading:boolean=true;
    public img:string='nopic';
    public name:string;
    public imgsrc:string=`https://aramis.app/static/users/${this.img}.jpg`;
    public posts:Array<any>=[];
    public data:any={};
    public type="post";
    public page:number=0;
    public showNumber:boolean=false
    @ViewChild('myinp',{static:true}) public myinp: any;
    constructor(public menuCtrl: MenuController, private route: ActivatedRoute,public api:Api, public user: User,public modalController: ModalController)  {
        
        this.route.params.subscribe( params => {
            if(params['id']){
                this.menuCtrl.enable(false, 'myMenu');
                this.uid=params['id']
                this.direct=true;
            }
        } );
    }
    showNum(){
        this.showNumber=true
    }
    showInput(){
        if(this.owner) {
            this.myinp.nativeElement.click();
        }
    }
    ngOnInit() {
        if(this.img)
            this.imgsrc=`https://aramis.app/static/users/${this.img}.jpg`
            
        this.getPost();
    }
    loadData($event){
        this.getPost($event);
    }
    changeListener(event){
        if (event.target.files && event.target.files[0]) {
            this.file= event.target.files[0];
            var reader = new FileReader();
            reader.readAsDataURL(event.target.files[0]); // read file as data url
            reader.onload = (event:any) => { // called once readAsDataURL is completed

                this.imgsrc = event.target.result;
            }
            this.uploadImageData();
        }
    }
    async uploadImageData() {
        const formData = new FormData();
        formData.append("thumbnail", this.file);
        formData.append("userKey", this.user.account.userKey);
        formData.append("vr", this.user.account.version);
        await this.user.myLoading()

        const upload$ = this.api.post("profileImage", formData).subscribe(mres => {
            this.user.checkStatus(mres,mres=> {
                this.img = mres["data"]["img"]
                this.user.ST.setItem('img', this.img);
                this.user.getUser()
                this.user.dismissLoading()
            },res=>{})
        },err=>{
            this.user.dismissLoading()
        });

    }
    public dismissModal() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.modalController.dismiss({
            'img':this.img,
            'dismissed': true
        });
    }
    async follow(){
        this.user.myLoading()
        const formData = new FormData();
        formData.append("userKey", this.user.account.userKey);
        formData.append("vr", this.user.account.version);
        formData.append("uid", this.uid );
        const upload$ = this.api.post("profile/follow", formData).subscribe(mres => {
            this.user.checkStatus(mres,mres=> {
                this.user.dismissLoading()
                this.data.followers++
                this.data.followed = true
            },res=>{})
        },err=>{
            this.user.dismissLoading()
        });
    }
    edit(){

    }
    async unfollow(){
        this.user.myLoading()
        const formData = new FormData();
        formData.append("userKey", this.user.account.userKey);
        formData.append("vr", this.user.account.version);
        formData.append("uid", this.uid );
        const upload$ = this.api.post("profile/unfollow", formData).subscribe(mres => {
            this.user.checkStatus(mres,mres=> {
                this.user.dismissLoading()
                this.data.followers--
                this.data.followed = false
            },res=>{})
        },err=>{
            this.user.dismissLoading()
        });
    }
    async getPost(event=null){
        if(this.page==0)
            this.loading=true
        const formData = new FormData();
        formData.append("userKey", this.user.account.userKey);
        formData.append("vr", this.user.account.version);
        formData.append("type", this.type);
        formData.append("direct", String(this.direct));
        formData.append("page", String(this.page+1));
        if(this.uidkey) {
            formData.append("uidkey", this.uidkey);
        }else {
            formData.append("uid", this.uid );
        }
        const upload$ = this.api.post("profile/get", formData).subscribe(mres => {
            // this.user.checkStatus(mres,mres=> {
                this.posts = this.posts.concat(mres["data"]["pst"]);
                
                if(this.page==0){
                    this.img=mres["data"]["dt"]["img"]
                    this.imgsrc=`https://aramis.app/static/users/${this.img}.jpg`
                    this.data = mres["data"]["dt"];
                    this.loading = false
                }
                this.page++;
                if(event){
                    event.target.complete();
                }
            // },res=>{
            //     if(event)
            //         event.target.complete();
            // });
        },err=>{
            if(event)
                event.target.complete();
            this.loading=false
        });
    }
    async presentEdit() {
        const modal = await this.modalController.create({
            component: EditUserPage,
            // cssClass: 'my-custom-class',
            componentProps: {
                data: this.data,
                name:this.name,
                img:this.img
            }
        });
        await modal.present();
        const { data } = await modal.onWillDismiss();
        this.data=data.data
        this.name=data.name
        this.img=data.img
        this.imgsrc=data.imgsrc
    }
    async presentComment(post) {
        const modal = await this.modalController.create({
            component: PostPage,
            // cssClass: 'my-custom-class',
            componentProps: {
                post:post
            }
        });
        await modal.present();
        const { data } = await modal.onWillDismiss();
        for( var i=0;i<this.posts.length;i++){
            if(data.dl){
                if(this.posts[i]==post){
                    this.posts.splice(this.posts.indexOf(post), 1)
                }
            }else {
                if(this.posts[i]==post){
                    this.posts[i]=data.post
                }
            }

        }

    }
    async showFollowers() {
        const modal = await this.modalController.create({
            component: UsersPage,
            // cssClass: 'my-custom-class',
            componentProps: {
                type:"followers",
                uid:this.uid
            }
        });
        await modal.present();
        const { data } = await modal.onWillDismiss();
    }
    async showFollowing() {
        const modal = await this.modalController.create({
            component: UsersPage,
            // cssClass: 'my-custom-class',
            componentProps: {
                type:"following",
                uid:this.uid
            }
        });
        await modal.present();
        const { data } = await modal.onWillDismiss();
    }
    segmentChanged(event){
        this.type=event.target.value;
        this.posts=[]
        this.page=0;
        this.getPost()
    }
    normalize(post){
        if(!post.text){
            return ""
        }else {
            return post.full || post.text.length<80?post.text:post.text.substring(0,post.text && post.text.indexOf(" ",80))+"..."
        }

    }

}
